//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import HiButton from "../../components/button/Index.vue";

export default {
  name: "HeaderComponent",
  props: {
    // 是否为通透效果，隐藏下方1px 下划线
    transparent: {
      type: Boolean,
      default: false,
    },
    backText: {
      type: String,
      default() {
        return this.$t("common.back");
      },
    },
    extraBackClick: {
      type: Function,
      default: () => {},
    },
    overrideBackClick: {
      type: Function,
      default: null,
    },
    // 隐藏返回按钮
    hideBack: {
      type: Boolean,
      default: false,
    },
    hideBackIcon: {
      // 有1个页面就是特意不能有返回箭头
      type: Boolean,
      default: false,
    },
  },
  components: { HiButton },
  methods: {
    /**
     * 返回按钮点击事件
     */
    backClick() {
      console.log(`this.overrideBackClick`, this.overrideBackClick);
      // 覆蓋原有back邏輯
      if (this.overrideBackClick) {
        console.log(`overrideBackClick`);
        this.overrideBackClick();
      } else {
        this.$router.go(-1);
      }
      this.extraBackClick();
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/header/Index.vue